import { Button, Group, Stack } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { PayablesReportContent } from "./PayablesReportContent";

export { PayablesReportContent } from "./PayablesReportContent";

export default function PayablesReportPage() {
  return (
    <Stack gap="lg" p="md">
      <Group>
        <Button
          component={Link}
          to="/reports"
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
        >
          Reports
        </Button>
      </Group>
      <PayablesReportContent />
    </Stack>
  );
}
